/**
 * Construit des initiales (1 ou 2 lettres) à partir d'un libellé ou, à défaut,
 * d'une valeur de repli (ex. un e-mail).
 * Générique : fonctionne avec un nom simple, composé, une adresse ou un nom de boutique.
 * @param {string} libelle - Libellé principal (nom complet, nom de boutique…)
 * @param {string} [repli] - Valeur utilisée si le libellé est vide
 * @returns {string} Une ou deux lettres majuscules, ou « ? » si rien n'est exploitable
 */
export const obtenirInitiales = (libelle, repli) => {
  const source = (libelle || repli || '').trim();
  if (!source) return '?';

  const mots = source.split(/[\s._@-]+/).filter(Boolean);
  return mots.slice(0, 2).map((mot) => mot[0]).join('').toUpperCase();
};
